import React from 'react';
import { useFormContext } from 'react-hook-form';
import { IDocumentValues, useDocumentCarouselStyles } from './documentCarouselUtil';
import Fieldset from '../connectedForm/Fieldset';
import { Switch } from '@fluentui/react-components';
import HintIcon from '../connectedForm/HintIcon';
import { useCookies } from 'react-cookie';
import { add } from 'date-fns';
import { DOCUMENT_SUMMARY } from '../../views/document/AcknowledgementDocumentCarouselCard';
import FluentSwitch from '../FluentWrapper/FluentSwitch';

/**
 * Provides the "show summary" option for printing.
 * @param singlePrint - If printing a single document, this field is not required and the component will return null.
 * @param setCookie - For updating the 'DOCUMENT_SUMMARY' cookie so the check state persists.
 *
 * Note - Unlike DocumentModal2, this does not check the "useCustomerDefaults" property as I 'think' that is intended per-document.
 *      - May be some scenario I'm missing. If reading this in a couple years, remove this comment as it's likely irrelevant ^^.
 */
const DocumentCarouselSummary = ({
  singlePrint,
  setCookie,
}: {
  singlePrint: boolean;
  setCookie: ReturnType<typeof useCookies>[1];
}) => {
  const { watch, setValue } = useFormContext<IDocumentValues>();
  const styles = useDocumentCarouselStyles();

  if (singlePrint) {
    return null;
  }

  const showSummary = watch('showSummary');

  return (
    <Fieldset cols={1 / 3} style={{ paddingLeft: 0, paddingRight: 0 }}>
      <FluentSwitch
        data-testid="document-carousel-show-summary"
        className={styles.switch}
        checked={showSummary}
        label={
          <span>
            Show Summary <HintIcon />
          </span>
        }
        labelStyle={'fluent'}
        onChange={(ev, data) => {
          const value = data.checked ?? false;
          setValue('showSummary', value, { shouldTouch: true, shouldDirty: true });
          setCookie(DOCUMENT_SUMMARY, value, {
            expires: add(new Date(), { years: 1 }),
          });
        }}
        hint={"Display summary of document's produced"}
      />
    </Fieldset>
  );
};

export default DocumentCarouselSummary;
